import Team from './TeamContainer';

export default Team;
